module.exports = __webpack_public_path__ + "static/media/crossnull.9de00198.svg";